<template>
  <div>
    <!-- BLUE Header -->
    <div class="header">
      <el-row>
        <el-col :span="20" :offset="2">
          <h1>Consulta la cobertura</h1>
        </el-col>
      </el-row>
    </div>
    <!-- END BLUE Header -->

    <el-row>
      <el-col :span="panelWidth" :offset="2">
        <el-card class="box-card">
          <CoverageFilter
            :shipper="shipper"
            :recipient="recipient"
            :package="package"
            :isLoading="isLoading"
            :countryOptions="countryOptions"
            :buttonValidate="buttonValidate"
            :_onCoverage="_onCoverage"
          />
        </el-card>

        <!-- Loading -->
        <div v-if="isLoading" class="loading-box">
          <div class="el-icon-loading loading-item"></div>
        </div>

        <!-- Results -->
        <el-row v-if="!isLoading" :gutter="10">
          <el-col :span="12" v-for="carrierItem in carriersList" :key="getId()">
            <el-card class="item-carrier-card">
              <el-row :gutter="0" class="item-align">
                <el-col :span="3">
                  <img
                    :src="getImgUrl(carrierItem.carrier_name)"
                    class="item-carrier-image"
                    style="object-fit:contain;"
                  />
                </el-col>
                <el-col :span="8">
                  <div class="item-carrier-name">
                    {{ carrierItem.carrier_name }}
                  </div>
                  <div class="item-carrier-service">
                    {{ carrierItem.service_type }}
                  </div>
                  <div class="item-carrier-origin">
                    {{ carrierItem.origin || "Desconocido" }}
                  </div>
                </el-col>
                <el-col :span="6" v-if="!carrierItem.error">
                  <div class="item-carrier-title">
                    Entrega
                  </div>
                  <div class="item-carrier-value">
                    {{ carrierItem.estimated_delivery_time || "Desconocido" }}
                  </div>
                </el-col>

                <el-col v-if="!carrierItem.error" :span="7">
                  <!-- covered -->
                  <div>
                    <li
                      :class="
                        carrierItem.covered
                          ? 'el-icon-success item-carrier-icon-ok'
                          : 'el-icon-error item-carrier-icon-not-ok'
                      "
                    ></li>
                    <span class="item-carrier-feature">Cobertura</span>
                  </div>
                  <!-- out_of_area -->
                  <div>
                    <li
                      :class="
                        carrierItem.out_of_area
                          ? 'el-icon-success item-carrier-icon-ok'
                          : 'el-icon-error item-carrier-icon-not-ok'
                      "
                    ></li>
                    <span class="item-carrier-feature">Fuera de área</span>
                  </div>
                  <!-- out_of_pickup -->
                  <div>
                    <li
                      :class="
                        carrierItem.out_of_pickup
                          ? 'el-icon-success item-carrier-icon-ok'
                          : 'el-icon-error item-carrier-icon-not-ok'
                      "
                    ></li>
                    <span class="item-carrier-feature">Fuera de Pickup</span>
                  </div>

                  <!-- is_ocurre -->
                  <div>
                    <li
                      :class="
                        carrierItem.is_ocurre
                          ? 'el-icon-success item-carrier-icon-ok'
                          : 'el-icon-error item-carrier-icon-not-ok'
                      "
                    ></li>
                    <span class="item-carrier-feature">Ocurre</span>
                  </div>
                </el-col>

                <el-col v-if="carrierItem.error" :span="13">
                  <el-alert
                    :title="carrierItem.message"
                    type="error"
                    :closable="false"
                  >
                  </el-alert>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CoverageFilter from "@/components/CoverageFilter.vue";
import { CSApi } from "@/libraries/api";

export default {
  name: "Coverage",
  components: {
    CoverageFilter,
  },
  data() {
    return {
      panelWidth: 20,
      shipper: {
        postal_code: "",
        country_code: "MX",
        address2: "",
      },
      recipient: {
        postal_code: "",
        country_code: "MX",
        address2: "",
      },
      package: {
        quantity: 1,
        weight: 1,
        width: 10,
        length: 10,
        height: 10,
      },
      countryOptions: [
        {
          value: "MX",
          label: "MX",
        },
        {
          value: "CO",
          label: "CO",
        },
        {
          value: "CL",
          label: "CL",
        },
      ],
      carriersList: [],
      internationalServicesTypes: [
        "INTERNATIONAL_ECONOMY",
        "INTERNATIONAL_PRIORITY",
        "INTERNATIONAL_WORLDWIDE",
        "WORLDWIDE",
        "EXPEDITED",
      ],
      isLoading: false,
    };
  },
  methods: {
    async getCoverage(body) {
      this.isLoading = true;
      this.carriersList = [];
      try {
        const response = await CSApi().post(`/coverage`, body);

        // If error
        if (!response?.data?.success)
          throw response?.data?.data?.error?.message || "Error";

        this.carriersList = this.sortBy(response.data.data, "carrier_name");
      } catch (error) {
        this.$message({
          message: error,
          type: "error",
          duration: 5000,
          showClose: true,
        });
      }
      this.isLoading = false;
    },

    _onCoverage() {
      // Create the body of the request
      const body = {
        carriers: [
          {
            carrier: "ALMEX",
            services: ["STANDARD", "LTL"],
          },
          {
            carrier: "CARSSA",
            services: ["STANDARD"],
          },
          {
            carrier: "DHL",
            services: [
              "STANDARD",
              "EXPRESS",
              "WORLDWIDE",
              "INTERNATIONAL_WORLDWIDE",
            ],
          },
          {
            carrier: "ESTAFETA",
            services: ["ESTAFETA_NEXT_DAY", "ESTAFETA_STANDARD", "LTL"],
          },
          {
            carrier: "FEDEX",
            services: [
              "FEDEX_EXPRESS_SAVER",
              "INTERNATIONAL_ECONOMY",
              "INTERNATIONAL_PRIORITY",
              "STANDARD_OVERNIGHT",
            ],
          },
          {
            carrier: "IENVIOS",
            services: ["NEXT_DAY"],
          },
          {
            carrier: "PAQUETEXPRESS",
            services: [
              "NACIONAL",
              "EXPRESS_NEXT_DAY",
              "EXPRESS_SECOND_DAY",
              "LTL",
            ],
          },
          {
            carrier: "QUIKEN",
            services: [
              "LOCAL_GUARANTEED",
              "LOCAL_EXPRESS",
              "NEXT_DAY_GUARANTEED",
              "NATIONAL_GROUND",
            ],
          },
          {
            carrier: "REDPACK",
            services: [
              "ECOEXPRESS",
              "EXPRESS",
              "DIA_SIGUIENTE",
              "STANDARD",
              "METROPOLITANO",
            ],
          },
          {
            carrier: "SENDEX",
            services: ["REGULAR", "REG", "STANDARD"],
          },
          {
            carrier: "TRESGUERRAS",
            services: ["STANDARD", "LTL"],
          },
          {
            carrier: "UPS",
            services: [
              "WORLDWIDE_EXPRESS",
              "EXPEDITED",
              "STANDARD",
              "EXPRESS_SAVER",
            ],
          },
          {
            carrier: "VENCEDOR",
            services: ["STANDARD"],
          },
          {
            carrier: "NINETYNINEMINUTES",
            services: ["NEXT_DAY_LOCAL", "NEXT_DAY_NACIONAL"],
          },
        ],
        request_data: {
          shipper: {
            postal_code: this.shipper.postal_code,
            country_code: this.shipper.country_code,
            address2: this.shipper.address2,
          },
          recipient: {
            postal_code: this.recipient.postal_code,
            country_code: this.recipient.country_code,
            address2: this.recipient.address2,
          },
          packages: [
            {
              quantity: parseFloat(this.package.quantity),
              weight: parseFloat(this.package.weight),
              width: parseFloat(this.package.width),
              length: parseFloat(this.package.length),
              height: parseFloat(this.package.height),
            },
          ],
        },
      };

      // Remove international services if the countries are the same
      if (this.shipper.country_code === this.recipient.country_code) {
        body.carriers = body.carriers.filter((carrier) => {
          carrier.services = carrier.services.filter(
            (service) => !this.internationalServicesTypes.includes(service)
          );
          return carrier;
        });
      } else {
        body.carriers = body.carriers.filter((carrier) => {
          carrier.services = carrier.services.filter((service) =>
            this.internationalServicesTypes.includes(service)
          );
          return carrier;
        });
      }

      this.getCoverage(body);
    },

    getId() {
      return (
        new Date().getTime() + Math.floor(Math.random() * 10000).toString()
      );
    },

    getImgUrl(carrierName) {
      return `https://app.skydropx.com/img/carriers/${carrierName}.svg`;
    },

    buttonValidate() {
      return (
        this.shipper.postal_code &&
        this.shipper.country_code &&
        this.recipient.postal_code &&
        this.recipient.country_code &&
        parseFloat(this.package.quantity) > 0 &&
        parseFloat(this.package.weight) > 0 &&
        parseFloat(this.package.width) > 0 &&
        parseFloat(this.package.length) > 0 &&
        parseFloat(this.package.height) > 0
      );
    },

    sortBy(array, property) {
      return array.sort((a, b) => {
        return a[property] >= b[property] ? 1 : -1;
      });
    },
  },

  computed: {
    ...mapState(["current_user"]),
    isAdmin() {
      return this.current_user.role == "admin";
    },
    isSupervisor() {
      return ["supervisor", "admin", "basic"].includes(this.current_user.role);
    },
  },
};
</script>

<style scoped>
h4 {
  margin: 2px;
}

.box-card {
  background: white;
  margin-bottom: 15px;
  padding: 20px 0px;
}

.item-align {
  display: flex;
  justify-content: left;
  flex-direction: row;
  align-items: center;
  min-height: 75px;
}

.item-carrier-card {
  margin-bottom: 10px;
  padding: 5px;
  min-height: 76px;
}

.item-carrier-image {
  width: 50px;
  height: 50px;
}

.item-carrier-name {
  font-size: 14px;
}

.item-carrier-service {
  font-size: 13px;
  color: #8c8c8c;
  word-break: break-word;
  margin-right: 5px;
}

.item-carrier-origin {
  font-size: 10px;
  color: white;
  float: left;
  background-color: #5567cd;
  margin-top: 5px;
  padding: 2px 8px;
  border-radius: 5px;
}

.item-carrier-title {
  font-size: 14px;
}
.item-carrier-value {
  font-size: 14px;
  color: #6b6b6b;
}

.item-carrier-feature {
  font-size: 12px;
  color: #6b6b6b;
  margin-bottom: 5px;
  margin-left: 4px;
}

.item-carrier-icon-ok {
  color: #2dce89;
  font-size: 14px;
}

.item-carrier-icon-not-ok {
  color: #f56c6c;
  font-size: 14px;
}

.loading-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px;
}
.loading-item {
  font-size: 25px;
}
</style>
